import { motion, useReducedMotion } from "framer-motion";
import { DURATION, EASE, inView } from "@/lib/motion";

/**
 * Reveal — scroll-triggered entrance. Falls back to a plain fade when the
 * visitor prefers reduced motion.
 */
export const Reveal = ({
  children,
  as = "div",
  delay = 0,
  y = 28,
  duration = DURATION.editorial,
  className,
  once = true,
  ...rest
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  const variants = {
    hidden: { opacity: 0, y: reduce ? 0 : y },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: reduce ? 0.2 : duration, ease: EASE.editorial, delay },
    },
  };

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ ...inView, once }}
      variants={variants}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

/** Stagger container for lists of Reveal children. */
export const RevealGroup = ({ children, className, stagger = 0.09, once = true }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ ...inView, once }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: reduce ? 0 : stagger } } }}
    >
      {children}
    </motion.div>
  );
};

export const RevealItem = ({ children, className, y = 24, as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={{
        hidden: { opacity: 0, y: reduce ? 0 : y },
        show: { opacity: 1, y: 0, transition: { duration: DURATION.editorial, ease: EASE.editorial } },
      }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
